import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={styles.container}>
      {/* TOP ROW: LINKS */}
      <div style={styles.linkRow}>
        <Link to="/about" style={styles.link}>ABOUT M.O.B.</Link>
        <span style={styles.separator}>|</span>
        <Link to="/terms" style={styles.link}>TERMS OF SERVICE</Link>
        <span style={styles.separator}>|</span>
        <Link to="/legal" style={styles.link}>LEGAL & PRIVACY</Link>
      </div>

      {/* MIDDLE ROW: COPYRIGHT */}
      <div style={styles.copy}>
        &copy; {currentYear} MILLION OR BUST PROTOCOL. ALL RIGHTS RESERVED.
      </div>

      {/* BOTTOM ROW: DISCLAIMER (CRITICAL) */}
      <div style={styles.disclaimer}>
        DISCLAIMER: The M.O.B. Protocol is a strategic educational tool. 
        We provide the roadmap; you provide the execution. Financial results vary based on effort.
      </div>
    </footer>
  );
};

const styles = {
  container: {
    width: '100%',
    background: '#050505',
    borderTop: '1px solid #222',
    padding: '30px 20px',
    textAlign: 'center',
    marginTop: 'auto', // Pushes footer to bottom if page is short
    fontFamily: 'Inter, sans-serif'
  },
  linkRow: {
    marginBottom: '15px',
    display: 'flex',
    justifyContent: 'center',
    gap: '15px',
    flexWrap: 'wrap'
  },
  link: {
    color: '#666',
    textDecoration: 'none',
    fontSize: '0.8rem',
    fontWeight: 'bold',
    transition: 'color 0.2s'
  },
  separator: {
    color: '#333'
  },
  copy: {
    color: '#444',
    fontSize: '0.75rem',
    marginBottom: '10px',
    fontFamily: 'Orbitron',
    letterSpacing: '1px'
  },
  disclaimer: {
    color: '#333',
    fontSize: '0.65rem',
    maxWidth: '600px',
    margin: '0 auto',
    lineHeight: '1.4'
  }
};

export default Footer;
